'use client';

import { cj } from 'src/utils/classNames';
import { Close } from '@drift-labs/icons';
import TopBarIconButton from 'src/components/TopBar/TopBarIconButton';
import BaseModal from 'src/components/primitives/BaseModal/BaseModal';
import NextLink from 'next/link';
import DriftTextLogo from 'src/components/Icons/DriftTextLogo';
import { Z_INDEX } from 'src/constants/zIndex';
import { TOP_BAR_MOBILE_PADDING } from 'src/components/TopBar/consts';
import MobileNavAccordion from 'src/components/Navigation/MobileNav/MobileNavAccordion/MobileNavAccordion';
import MobileNavFooter from 'src/components/Navigation/MobileNav/MobileNavFooter';
import useMobileNav from 'src/components/Navigation/MobileNav/hooks/useMobileNav';

const CLOSE_BUTTON_STYLE = {
	top: TOP_BAR_MOBILE_PADDING.vertical,
	right: TOP_BAR_MOBILE_PADDING.horizontal,
};

const MODAL_CONTAINER_STYLE = {
	top: TOP_BAR_MOBILE_PADDING.vertical,
	bottom: TOP_BAR_MOBILE_PADDING.vertical,
	left: TOP_BAR_MOBILE_PADDING.horizontal,
	// `34` is unfortunately a magic number: the width of the close button.
	right: `${34 + CLOSE_BUTTON_STYLE.right * 2}px`,
};

const MODAL_BG_CLASSNAME = 'bg-input-bg';

export default function MobileNav() {
	const { close, isOpen, isOpenRaf } = useMobileNav();

	return (
		<>
			{/* Side panel containing the nav items. */}
			<BaseModal.Container
				className={cj(
					'fixed h-[unset] w-[unset] rounded-sm transition-transform duration-100',
					isOpenRaf ? 'translate-x-0' : '-translate-x-full'
				)}
				style={MODAL_CONTAINER_STYLE}
				onClose={close}
				disableOverlay
				dataTestId="mobile-nav-menu"
			>
				<BaseModal.Title
					className={MODAL_BG_CLASSNAME}
					innerWrapperClassName="border-b-0"
				>
					<NextLink href="/SOL-PERP" onClick={close}>
						<DriftTextLogo />
					</NextLink>
				</BaseModal.Title>

				<BaseModal.Body className={MODAL_BG_CLASSNAME}>
					<MobileNavAccordion />
				</BaseModal.Body>

				<BaseModal.Footer
					// `px-0` here so we can have dividers that span the entire container.
					className={cj('flex-col items-start px-0', MODAL_BG_CLASSNAME)}
				>
					<MobileNavFooter />
				</BaseModal.Footer>
			</BaseModal.Container>

			{/* Custom overlay. */}
			<div
				className={cj('fixed inset-0 bg-overlay', Z_INDEX.modalContainer)}
				onClick={close}
			/>

			{/* "Floating" close button. */}
			{isOpen && (
				<TopBarIconButton
					className={cj(
						'fixed transition-opacity duration-100',
						isOpenRaf ? 'opacity-100' : 'opacity-0',
						Z_INDEX.modalContainer
					)}
					style={CLOSE_BUTTON_STYLE}
					icon={Close}
					onClick={close}
					dataTestId="mobile-nav-close"
				/>
			)}
		</>
	);
}
